import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Accept: [],
  Pending: [],

};
//internally using immer lib (can create mutable state)
export const franchiseDivisionSlice = createSlice({
  name: "franchiseDivisionData",
  initialState,
  reducers: {
    AcceptAllDivision: (state, action) => {
      state.Accept = action.payload;
    },
    PendingAllDivision: (state, action) => {
      state.Pending = action.payload;
    },
  },
});
// this is for dispatch
export const { AcceptAllDivision,PendingAllDivision } = franchiseDivisionSlice.actions;
// this is for configureStore
export default franchiseDivisionSlice.reducer;
